import { makeVar } from '@apollo/client';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { WEBAPP_KEY } from 'shared/get-env';

export const chaptersText = makeVar({});

export const updateChapterText = (chapterId, text) => {
	const currentValue = { ...chaptersText() };

	currentValue[chapterId] = text;

	chaptersText(currentValue);
};

export const fetchChapterText = async (chapterId, link) => {
	const currentText = readChapterText(chapterId);

	if (currentText || !chapterId || !link) {
		return currentText;
	}

	const isSupportLink = link.includes('support');
	const supportHeader = {
		'x-auth': `Bearer ${WEBAPP_KEY}`,
	};
	const result = await axios.get(isSupportLink ? link : `${link}?caching=${uuidv4()}`, {
		headers: isSupportLink ? supportHeader : {},
	});
	const text = !isSupportLink ? result.data : result.data.chapter;

	updateChapterText(chapterId, text);

	return text;
};

export const readChapterText = chapterId => {
	const text = chaptersText()[chapterId];
	return text || '';
};

export const clearChaptersText = () => {
	chaptersText({});
};
